import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ClockIcon } from 'lucide-react';
interface FinalCTASectionProps {
  onBookCall: () => void;
}
export function FinalCTASection({
  onBookCall
}: FinalCTASectionProps) {
  return <section className="bg-navy py-20 md:py-28 relative overflow-hidden" data-id="element-17">
      {/* Background Elements */}
      <div className="absolute inset-0" data-id="element-18">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-3xl" data-id="element-19" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-21">
          {/* Headline */}
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-22">
            Stop Trading Time for Money.{' '}
            <span className="text-gold" data-id="element-23">Start Building a Profit Machine.</span>
          </h2>

          {/* Sub-headline */}
          <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-24">
            Your competitors will continue to hire expensive, inefficient staff.
            You can make the smart choice. Book your free, no-obligation AI ROI
            Assessment now and let us show you the exact roadmap to a more
            profitable, efficient, and stress-free firm.
          </p>

          {/* Final CTA */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="mb-4" data-id="element-25">
            <CTAButton onClick={onBookCall} size="large" data-id="element-26">
              Start Your Application
            </CTAButton>
          </motion.div>

          {/* Urgency Text */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex items-center justify-center gap-2 text-gold" data-id="element-27">
            <ClockIcon className="w-4 h-4" data-id="element-28" />
            <span className="text-sm font-medium" data-id="element-29">
              Limited Spots Available Each Month
            </span>
          </motion.div>
        </motion.div>

        {/* Footer */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-20 pt-8 border-t border-white/10" data-id="element-30">
          <p className="text-muted text-sm" data-id="element-31">
            © 2026 The Automatic Paralegal Assistant. All rights reserved.
          </p>
          <p className="text-muted/60 text-xs mt-2" data-id="element-32">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, this site is NOT endorsed by Facebook in any way.
          </p>
        </motion.div>
      </div>
    </section>;
}